module.exports = __webpack_public_path__ + "img/portugal-blood-diseases-male.12a1fdab.png";